// extracted by mini-css-extract-plugin
module.exports = {"btns":"supplyDrawer_btns__bMNJH"};